<template>
  <div class="ppt" aria-hidden="true" data-testid="public-progress-track">
    <div class="ppt-curseur"></div>
  </div>
</template>

<script setup>
/**
 * UNE ATTENTE QUI NE CLIGNOTE PAS (règle P33 de docs/PUBLIQUES-V2.md) : une
 * piste fine, et un segment qui la traverse lentement. Sous
 * `prefers-reduced-motion`, rien ne traverse : la piste se remplit et respire.
 *
 * Extraite à la deuxième occurrence (règle des deux occurrences), depuis
 * l'écran de chargement du back-office (`AppLoadingScreen`), par la carte des
 * centres embarquée (`/embed/map`).
 *
 * Purement décorative (`aria-hidden`) : c'est le conteneur qui porte
 * `role="status"` et la phrase qui dit ce qu'on attend. La largeur se règle par
 * une classe posée par le parent (220 px par défaut, jamais plus large que son
 * conteneur).
 */
</script>

<style scoped>
.ppt {
  position: relative;
  width: 220px;
  max-width: 100%;
  height: 3px;
  overflow: hidden;
  border-radius: var(--radius-full);
  background: var(--color-primary-lighter);
}

.ppt-curseur {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40%;
  border-radius: var(--radius-full);
  background: var(--color-primary);
  animation: ppt-glisse 1500ms cubic-bezier(0.65, 0, 0.35, 1) infinite;
}

@keyframes ppt-glisse {
  from { transform: translateX(-110%); }
  to { transform: translateX(260%); }
}

/* Mouvement réduit : la piste se remplit et respire, sans rien qui traverse. */
@media (prefers-reduced-motion: reduce) {
  .ppt-curseur {
    width: 100%;
    animation: ppt-respire 2400ms ease-in-out infinite;
  }

  @keyframes ppt-respire {
    0%, 100% { opacity: 0.35; }
    50% { opacity: 1; }
  }
}
</style>
